import NavbarAvatar from "component/navbar/avatar/navbar_avatar";
import { useLogged } from "hook/useLogged";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const NavbarAction = () => {
  // -------------------------- VAR -----------------------------
  const { logged } = useLogged();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLogged = () => {
    if (logged) {
      return <NavbarAvatar />;
    }
  };

  const renderUnlogged = () => {
    if (!logged) {
      return (
        <>
          <a
            href="#giai-phap"
            className="hover:border-accent-500 py-2 text-sm font-medium text-gray-300 transition-all hover:border-b-2 hover:text-white"
          >
            Giải pháp
          </a>

          <a
            href="#bao-mat"
            className="hover:border-accent-500 py-2 text-sm font-medium text-gray-300 transition-all hover:border-b-2 hover:text-white"
          >
            Bảo mật
          </a>
          <a
            href="/login"
            className="bg-primary-700 hover:bg-primary-500 rounded-xl border border-white/10 px-6 py-2.5 text-sm font-bold text-white shadow-lg transition-colors"
          >
            Đăng nhập
          </a>
        </>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderLogged()}
      {renderUnlogged()}
    </>
  );
};
export default NavbarAction;
